import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import UserSubscriptionListing from './components/UserSubscriptionListing';
import MembershipListing from './components/MembershipListing';
import Col12 from './components/Col12';
import { loadAllData } from '../../actions/membershipActions';
import membershipStore from '../../stores/membershipStore';
import { T } from '../../stores/textStore';


class UserSubscriptionsView extends Component {
	isCancellable(result) {
		if (result.status === 'current' && !result.end_date) {
			return true;
		}
		return false;
	}

	isUpgradable(result) {
		return (result.subscription.membership.get_level_display !== 'Onehouse Community')
	}

	componentDidMount() {
		//membershipStore.alerts.replace([]);
	}

	render() {		
		const { membershipStore } = this.props;
		if (membershipStore.reloadData.get()) {
			window.location.reload(false);
		}
		if (!membershipStore.isDataLoaded()) {
			return (
				<Col12>
					<Loader message={membershipStore.processingMessage.get()} />
				</Col12>
			);
		}
		const currentUserSubscription = membershipStore.getCurrentUserSubscription();
		const pendingUserSubscription = membershipStore.getPendingUserSubscription();
		console.log('KKKKKK', currentUserSubscription);
		console.log('UUUUUUU', currentUserSubscription.subscription.membership);
		if (currentUserSubscription.subscription.membership.retired) {
			return (
				<Col12>
					<div className="alert-warning text-center py-2" role="alert">
						{T('You have a retired plan')}
					</div>
					<p className="mb-1">
						{T('You cannot make changes to your current membership plan because you have the following retired plan.')}
					</p>
					<h5 className="mb-3">
						{currentUserSubscription.subscription.membership.name}
					</h5>
					<h6>{T('To make changes, please contact our customer care team:')}</h6>
					<p>
						{T('Monday – Thursday 9 AM - 4PM PST')}<br />
						{T('Friday 9 AM – 2:30 PM PST')}<br />
						{T('US &amp; Canada')} 888-898-8358<br />
						{T('International')} 424-332-5381<br />
						{T('Email')} care@kabbalah.com						
					</p>
				</Col12>				
			)
		}				
		return (
			<div className="container mt-4">
				<div className="row">	
					<div className="col-12 mb-4">
						<h1 className="text-center tkc-text-red font-weight-bold">
							{T('Manage Your Membership Plan')}
						</h1>
					</div>				
					<div className="col-lg-4">		
						<UserSubscriptionListing 
								key={currentUserSubscription.start_date} 
								userSubscription={currentUserSubscription} 
						/> 	
					</div>													
					{pendingUserSubscription &&
						<div className="col-lg-4">
							<UserSubscriptionListing 
									key={pendingUserSubscription.start_date} 
									userSubscription={pendingUserSubscription} 
							/>
						</div>
					}
					{!pendingUserSubscription && membershipStore.membershipsResultSet.get().results
							.filter(result => 
								result.slug !== currentUserSubscription.subscription.membership.slug
							)
							.filter(result => result.slug !== 'free')
							.sort((a, b) => a.level - b.level)
							.map(result =>
						<div className="col-lg-4" key={result.slug}>
							<MembershipListing membership={result} />
						</div>
					)}										
				</div>
			</div>
		);		
	}
}

export default withRouter(inject('membershipStore')(observer(UserSubscriptionsView)));



// WEBPACK FOOTER //
// ./src/views/membership/UserSubscriptionsView.js